import React, { useState } from 'react';
import i18n from '../../utils/i18n';

const ArchivedBadge = ({ color = '#999' }) => {
  const [open, setOpen] = useState(false);

  return (
    <span
      style={{ position: 'relative', display: 'inline-flex', alignItems: 'center' }}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <b style={{ color }}>
        {i18n.t('playerSurvey.archived', { defaultValue: 'Archived' })}
      </b>
      {open && (
        <span style={{
          position: 'absolute',
          bottom: '100%',
          left: '50%',
          transform: 'translateX(-50%)',
          marginBottom: 6,
          background: '#333',
          color: '#fff',
          fontSize: '1em',
          borderRadius: 4,
          padding: '8px 12px',
          width: 300,
          whiteSpace: 'normal',
          zIndex: 999,
          boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
          lineHeight: 1.5,
          pointerEvents: 'none',
        }}>
          {i18n.t('playerSurvey.archivedTooltip', { defaultValue: 'This means that the child has outgrown this screening interval.' })}
        </span>
      )}
    </span>
  );
};

export default ArchivedBadge;
